import CheckOutTitleWithIllustration from "@components/CheckOutTitleWithIllustration/CheckOutTitleWithIllustration";

export default CheckOutTitleWithIllustration;
